<template>
  <v-container>
      <v-row class="mb-2 justify-space-around">
        <v-col cols="12" md="4" v-if="!inSet">
            <h3 class="titulo text-h7">Información del Documento</h3>
           <table>
          <tbody>
            <tr>
              <td class="text-right">
                Documento:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black ">{{purchaseInvoice.document_id}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Fecha de Recepción:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black ">{{purchaseInvoice.date_received|moment('DD/MM/YYYY')}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                RUT:
              </td>
              <td class="text-left px-3">
                  <div></div>
                <div class="font-weight-black ">{{purchaseInvoice.rutEmisor}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Razón Social:
              </td>
              <td class="text-left px-3">
                  <div></div>
                <div class="font-weight-black ">{{purchaseInvoice.rznSocEmisor}}</div>
              </td>
            </tr>
        
            <tr>
              <td class="text-right">
                Neto:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black ">{{purchaseInvoice.get_subtotal| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                IVA ({{purchaseInvoice.iva}}%):
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black ">{{purchaseInvoice.get_iva| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Total:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black ">{{purchaseInvoice.get_total| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Pagado:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black ">{{purchaseInvoice.get_payed| moneda}}</div>
              </td>
            </tr>
            <tr>
              <td class="text-right">
                Saldo:
              </td>
              <td class="text-left px-3">
                <div class="font-weight-black ">{{purchaseInvoice.get_total-purchaseInvoice.get_payed| moneda}}</div>
              </td>
            </tr>
          </tbody>
        </table> 
        </v-col>
        <v-col cols="12" :md="inSet?12:8">
            <v-data-table
                class=""
                :headers="headers"
                :items="purchaseInvoice.details"
                :items-per-page="-1"
                :loading="loading"
                :item-class="()=>{return 'row-style-normal'}"
                sort-by='nro_linea'
                :sort-desc="false"
                hide-default-footer
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'fas fa-angle-double-left',
                    lastIcon: 'fas fa-angle-double-right',
                    prevIcon: 'fas fa-angle-left',
                    nextIcon: 'fas fa-angle-right'
                }">
                <template #top>
                  <h3 class="titulo text-h7">Productos</h3>
                </template>
                <template #no-data>
                  <v-alert :value="true"  icon="fas fa-info-circle" class="ma-4">
                    No existen productos registrados
                  </v-alert>
                </template>
                <template #item.qty="{ item }">
                    {{item.qty| number('0.00')}}
                </template>
                <template #item.price="{ item }">
                    {{item.price| moneda}}
                </template>
                <template #item.total="{ item }">
                    {{item.price*item.qty| moneda}}
                </template>
            </v-data-table>
        </v-col>
	</v-row>
  </v-container>
</template>

<script>
export default {
    name:'PurchaseInvoiceDetail',
    props:['purchaseInvoice','inSet'],
    data(){
        return{
            headers:[
            {
            text: 'Item',
            align: 'start',
            value: 'nro_linea',
            class: 'table-header-2',
            show:true,
            align:'end',
            sortable: false,
            },
            {
            text: 'Código',
            align: 'start',
            value: 'sku',
            class: 'table-header-2',
            show:true,
            align:'start',
            sortable: false
            },
            {
            text: 'Descripción',
            align: 'start',
            value: 'name',
            class: 'table-header-2',
            show:true,
            align:'start',
            sortable: false
            },
            {
            text: 'Cant.',
            align: 'start',
            value: 'qty',
            class: 'table-header-2',
            show:true,
            align:'end',
            sortable: false
            },
            {
            text: 'Unidad',
            align: 'start',
            value: 'unit',
            class: 'table-header-2',
            show:true,
            align:'center',
            sortable: false
            },
            {
            text: 'Prec. Unit.',
            align: 'start',
            value: 'price',
            class: 'table-header-2',
            show:true,
            align:'end',
            sortable: false
            },
            {
            text: 'Total',
            align: 'start',
            value: 'total',
            class: 'table-header-2',
            show:true,
            align:'end',
            sortable: false
            }, 
            ],
            loading:false,
        }
    },
}

</script> 